import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";

import {
  setReferral,
  setMessage,
  submitForm,
  updatePerson,
  updateOrganization,
} from "../modules/actions";
import { countryOptions, referralOptions, stateOptions } from "../config";

import DropDown from "./DropDown";
import TextInput from "./TextInput";
import Switch from "./Switch";

const MessageStep = ({
  referral,
  message,
  dispatch,
  submitting,
  organization,
  person,
}) => {
  const { type } = organization;
  const messageInput = useRef(null);

  const [dataAgreement, setDataAgreement] = useState(false);

  useEffect(() => {
    if (messageInput && messageInput.current) {
      messageInput.current.focus();
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(submitForm());
  };

  const invalidSize =
    (organization.type === "club" || organization.type === "community") &&
    organization.size === "";

  const invalidCountryState =
    organization.country === "Deutschland" && !organization.state;

  const valid =
    organization.name.length > 0 &&
    person.name.length > 0 &&
    !invalidCountryState &&
    !invalidSize &&
    dataAgreement;

  return (
    <form onSubmit={handleSubmit}>
      <DropDown
        label={`${
          type === "pos" ? "Woher kennen Sie uns?" : "Woher kennst Du uns?"
        } (optional)`}
        options={referralOptions}
        value={referral}
        onChange={({ target: { value } }) => dispatch(setReferral(value))}
        includeBlank
      />
      <DropDown
        label={
          type === "pos"
            ? "In welchem Land befindet sich ihr Markt?"
            : "In welchem Land befindet Ihr euch?"
        }
        options={countryOptions}
        value={organization.country}
        onChange={({ target: { value } }) =>
          dispatch(updateOrganization("country", value))
        }
      />
      {organization.country === "Deutschland" && (
        <DropDown
          label="Und in welchem Bundesland?"
          options={stateOptions}
          value={organization.state}
          onChange={({ target: { value } }) =>
            dispatch(updateOrganization("state", value))
          }
          includeBlank
        />
      )}
      <TextInput
        label="Nachricht an uns (optional)"
        value={message}
        onChange={({ target: { value } }) => dispatch(setMessage(value))}
        ref={messageInput}
        area
      />
      <Switch
        label="Datenschutz"
        value={dataAgreement}
        onChange={() => setDataAgreement(!dataAgreement)}
        subtext={() => (
          <div>
            Ich habe die{" "}
            <a href="/datenschutz" target="_blank" rel="noopener noreferrer" class="more-link">
              Datenschutzerklärung
            </a>{" "}
            gelesen und akzeptiere diese.
          </div>
        )}
      />
      <div style={{ marginTop: "-2rem" }}>
        <Switch
          label="Anmeldung zum Newsletter"
          value={person.newsletterOptIn}
          onChange={() =>
            dispatch(updatePerson("newsletterOptIn", !person.newsletterOptIn))
          }
          subtext="Ich erlaube Stickerstars, meine Angaben zu speichern und auszuwerten, um mir passende E-Mails zu neuen Produkten und Inhalten zu senden. Über einen Link im Newsletter kann ich dies jederzeit widerrufen."
        />
      </div>
      <div className="controls">
        <button
          className="button"
          type="submit"
          disabled={submitting || !valid}
        >
          {submitting ? "..." : "Abschicken"}
        </button>
      </div>
    </form>
  );
};

const mapStateToProps = (state) => ({
  referral: state.referral,
  submitting: state.submitting,
  message: state.message,
  organization: state.organization,
  person: state.person,
});

export default connect(mapStateToProps)(MessageStep);
